/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as NextClassesImport } from './routes/next-classes'
import { Route as HomeworkImport } from './routes/homework'
import { Route as FlagsImport } from './routes/flags'
import { Route as CoordinationImport } from './routes/coordination'
import { Route as ClassesImport } from './routes/classes'
import { Route as IndexImport } from './routes/index'
import { Route as StudentsIndexImport } from './routes/students/index'
import { Route as FeedbackIndexImport } from './routes/feedback/index'
import { Route as ClassesIndexImport } from './routes/classes/index'
import { Route as StudentsStudentIdImport } from './routes/students/$studentId'
import { Route as StudentsStudentIdIndexImport } from './routes/students/$studentId/index'
import { Route as StudentsStudentIdFeedbackImport } from './routes/students/$studentId/feedback'
import { Route as EventEventIdHomeworkImport } from './routes/event/$eventId/homework'
import { Route as ClassesClassIdHomeworkImport } from './routes/classes/$classId/homework'
import { Route as StudentsStudentIdFeedbackIndexImport } from './routes/students/$studentId/feedback/index'
import { Route as StudentsStudentIdFeedbackFeedbackIdImport } from './routes/students/$studentId/feedback/$feedbackId'
import { Route as EventEventIdScorecardScorecardIdImport } from './routes/event/$eventId/scorecard/$scorecardId'
import { Route as ClassesClassIdStudentStudentIdImport } from './routes/classes/$classId/student/$studentId'

// Create/Update Routes

const NextClassesRoute = NextClassesImport.update({
  id: '/next-classes',
  path: '/next-classes',
  getParentRoute: () => rootRoute,
} as any)

const HomeworkRoute = HomeworkImport.update({
  id: '/homework',
  path: '/homework',
  getParentRoute: () => rootRoute,
} as any)

const FlagsRoute = FlagsImport.update({
  id: '/flags',
  path: '/flags',
  getParentRoute: () => rootRoute,
} as any)

const CoordinationRoute = CoordinationImport.update({
  id: '/coordination',
  path: '/coordination',
  getParentRoute: () => rootRoute,
} as any)

const ClassesRoute = ClassesImport.update({
  id: '/classes',
  path: '/classes',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const StudentsIndexRoute = StudentsIndexImport.update({
  id: '/students/',
  path: '/students/',
  getParentRoute: () => rootRoute,
} as any)

const FeedbackIndexRoute = FeedbackIndexImport.update({
  id: '/feedback/',
  path: '/feedback/',
  getParentRoute: () => rootRoute,
} as any)

const ClassesIndexRoute = ClassesIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ClassesRoute,
} as any)

const StudentsStudentIdRoute = StudentsStudentIdImport.update({
  id: '/students/$studentId',
  path: '/students/$studentId',
  getParentRoute: () => rootRoute,
} as any)

const StudentsStudentIdIndexRoute = StudentsStudentIdIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => StudentsStudentIdRoute,
} as any)

const StudentsStudentIdFeedbackRoute = StudentsStudentIdFeedbackImport.update({
  id: '/feedback',
  path: '/feedback',
  getParentRoute: () => StudentsStudentIdRoute,
} as any)

const EventEventIdHomeworkRoute = EventEventIdHomeworkImport.update({
  id: '/event/$eventId/homework',
  path: '/event/$eventId/homework',
  getParentRoute: () => rootRoute,
} as any)

const ClassesClassIdHomeworkRoute = ClassesClassIdHomeworkImport.update({
  id: '/$classId/homework',
  path: '/$classId/homework',
  getParentRoute: () => ClassesRoute,
} as any)

const StudentsStudentIdFeedbackIndexRoute =
  StudentsStudentIdFeedbackIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StudentsStudentIdFeedbackRoute,
  } as any)

const StudentsStudentIdFeedbackFeedbackIdRoute =
  StudentsStudentIdFeedbackFeedbackIdImport.update({
    id: '/$feedbackId',
    path: '/$feedbackId',
    getParentRoute: () => StudentsStudentIdFeedbackRoute,
  } as any)

const EventEventIdScorecardScorecardIdRoute =
  EventEventIdScorecardScorecardIdImport.update({
    id: '/event/$eventId/scorecard/$scorecardId',
    path: '/event/$eventId/scorecard/$scorecardId',
    getParentRoute: () => rootRoute,
  } as any)

const ClassesClassIdStudentStudentIdRoute =
  ClassesClassIdStudentStudentIdImport.update({
    id: '/$classId/student/$studentId',
    path: '/$classId/student/$studentId',
    getParentRoute: () => ClassesRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/classes': {
      id: '/classes'
      path: '/classes'
      fullPath: '/classes'
      preLoaderRoute: typeof ClassesImport
      parentRoute: typeof rootRoute
    }
    '/coordination': {
      id: '/coordination'
      path: '/coordination'
      fullPath: '/coordination'
      preLoaderRoute: typeof CoordinationImport
      parentRoute: typeof rootRoute
    }
    '/flags': {
      id: '/flags'
      path: '/flags'
      fullPath: '/flags'
      preLoaderRoute: typeof FlagsImport
      parentRoute: typeof rootRoute
    }
    '/homework': {
      id: '/homework'
      path: '/homework'
      fullPath: '/homework'
      preLoaderRoute: typeof HomeworkImport
      parentRoute: typeof rootRoute
    }
    '/next-classes': {
      id: '/next-classes'
      path: '/next-classes'
      fullPath: '/next-classes'
      preLoaderRoute: typeof NextClassesImport
      parentRoute: typeof rootRoute
    }
    '/students/$studentId': {
      id: '/students/$studentId'
      path: '/students/$studentId'
      fullPath: '/students/$studentId'
      preLoaderRoute: typeof StudentsStudentIdImport
      parentRoute: typeof rootRoute
    }
    '/classes/': {
      id: '/classes/'
      path: '/'
      fullPath: '/classes/'
      preLoaderRoute: typeof ClassesIndexImport
      parentRoute: typeof ClassesImport
    }
    '/feedback/': {
      id: '/feedback/'
      path: '/feedback'
      fullPath: '/feedback'
      preLoaderRoute: typeof FeedbackIndexImport
      parentRoute: typeof rootRoute
    }
    '/students/': {
      id: '/students/'
      path: '/students'
      fullPath: '/students'
      preLoaderRoute: typeof StudentsIndexImport
      parentRoute: typeof rootRoute
    }
    '/classes/$classId/homework': {
      id: '/classes/$classId/homework'
      path: '/$classId/homework'
      fullPath: '/classes/$classId/homework'
      preLoaderRoute: typeof ClassesClassIdHomeworkImport
      parentRoute: typeof ClassesImport
    }
    '/event/$eventId/homework': {
      id: '/event/$eventId/homework'
      path: '/event/$eventId/homework'
      fullPath: '/event/$eventId/homework'
      preLoaderRoute: typeof EventEventIdHomeworkImport
      parentRoute: typeof rootRoute
    }
    '/students/$studentId/feedback': {
      id: '/students/$studentId/feedback'
      path: '/feedback'
      fullPath: '/students/$studentId/feedback'
      preLoaderRoute: typeof StudentsStudentIdFeedbackImport
      parentRoute: typeof StudentsStudentIdImport
    }
    '/students/$studentId/': {
      id: '/students/$studentId/'
      path: '/'
      fullPath: '/students/$studentId/'
      preLoaderRoute: typeof StudentsStudentIdIndexImport
      parentRoute: typeof StudentsStudentIdImport
    }
    '/classes/$classId/student/$studentId': {
      id: '/classes/$classId/student/$studentId'
      path: '/$classId/student/$studentId'
      fullPath: '/classes/$classId/student/$studentId'
      preLoaderRoute: typeof ClassesClassIdStudentStudentIdImport
      parentRoute: typeof ClassesImport
    }
    '/event/$eventId/scorecard/$scorecardId': {
      id: '/event/$eventId/scorecard/$scorecardId'
      path: '/event/$eventId/scorecard/$scorecardId'
      fullPath: '/event/$eventId/scorecard/$scorecardId'
      preLoaderRoute: typeof EventEventIdScorecardScorecardIdImport
      parentRoute: typeof rootRoute
    }
    '/students/$studentId/feedback/$feedbackId': {
      id: '/students/$studentId/feedback/$feedbackId'
      path: '/$feedbackId'
      fullPath: '/students/$studentId/feedback/$feedbackId'
      preLoaderRoute: typeof StudentsStudentIdFeedbackFeedbackIdImport
      parentRoute: typeof StudentsStudentIdFeedbackImport
    }
    '/students/$studentId/feedback/': {
      id: '/students/$studentId/feedback/'
      path: '/'
      fullPath: '/students/$studentId/feedback/'
      preLoaderRoute: typeof StudentsStudentIdFeedbackIndexImport
      parentRoute: typeof StudentsStudentIdFeedbackImport
    }
  }
}

// Create and export the route tree

interface ClassesRouteChildren {
  ClassesIndexRoute: typeof ClassesIndexRoute
  ClassesClassIdHomeworkRoute: typeof ClassesClassIdHomeworkRoute
  ClassesClassIdStudentStudentIdRoute: typeof ClassesClassIdStudentStudentIdRoute
}

const ClassesRouteChildren: ClassesRouteChildren = {
  ClassesIndexRoute: ClassesIndexRoute,
  ClassesClassIdHomeworkRoute: ClassesClassIdHomeworkRoute,
  ClassesClassIdStudentStudentIdRoute: ClassesClassIdStudentStudentIdRoute,
}

const ClassesRouteWithChildren =
  ClassesRoute._addFileChildren(ClassesRouteChildren)

interface StudentsStudentIdFeedbackRouteChildren {
  StudentsStudentIdFeedbackFeedbackIdRoute: typeof StudentsStudentIdFeedbackFeedbackIdRoute
  StudentsStudentIdFeedbackIndexRoute: typeof StudentsStudentIdFeedbackIndexRoute
}

const StudentsStudentIdFeedbackRouteChildren: StudentsStudentIdFeedbackRouteChildren =
  {
    StudentsStudentIdFeedbackFeedbackIdRoute:
      StudentsStudentIdFeedbackFeedbackIdRoute,
    StudentsStudentIdFeedbackIndexRoute: StudentsStudentIdFeedbackIndexRoute,
  }

const StudentsStudentIdFeedbackRouteWithChildren =
  StudentsStudentIdFeedbackRoute._addFileChildren(
    StudentsStudentIdFeedbackRouteChildren,
  )

interface StudentsStudentIdRouteChildren {
  StudentsStudentIdFeedbackRoute: typeof StudentsStudentIdFeedbackRouteWithChildren
  StudentsStudentIdIndexRoute: typeof StudentsStudentIdIndexRoute
}

const StudentsStudentIdRouteChildren: StudentsStudentIdRouteChildren = {
  StudentsStudentIdFeedbackRoute: StudentsStudentIdFeedbackRouteWithChildren,
  StudentsStudentIdIndexRoute: StudentsStudentIdIndexRoute,
}

const StudentsStudentIdRouteWithChildren =
  StudentsStudentIdRoute._addFileChildren(StudentsStudentIdRouteChildren)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/classes': typeof ClassesRouteWithChildren
  '/coordination': typeof CoordinationRoute
  '/flags': typeof FlagsRoute
  '/homework': typeof HomeworkRoute
  '/next-classes': typeof NextClassesRoute
  '/students/$studentId': typeof StudentsStudentIdRouteWithChildren
  '/classes/': typeof ClassesIndexRoute
  '/feedback': typeof FeedbackIndexRoute
  '/students': typeof StudentsIndexRoute
  '/classes/$classId/homework': typeof ClassesClassIdHomeworkRoute
  '/event/$eventId/homework': typeof EventEventIdHomeworkRoute
  '/students/$studentId/feedback': typeof StudentsStudentIdFeedbackRouteWithChildren
  '/students/$studentId/': typeof StudentsStudentIdIndexRoute
  '/classes/$classId/student/$studentId': typeof ClassesClassIdStudentStudentIdRoute
  '/event/$eventId/scorecard/$scorecardId': typeof EventEventIdScorecardScorecardIdRoute
  '/students/$studentId/feedback/$feedbackId': typeof StudentsStudentIdFeedbackFeedbackIdRoute
  '/students/$studentId/feedback/': typeof StudentsStudentIdFeedbackIndexRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/coordination': typeof CoordinationRoute
  '/flags': typeof FlagsRoute
  '/homework': typeof HomeworkRoute
  '/next-classes': typeof NextClassesRoute
  '/classes': typeof ClassesIndexRoute
  '/feedback': typeof FeedbackIndexRoute
  '/students': typeof StudentsIndexRoute
  '/classes/$classId/homework': typeof ClassesClassIdHomeworkRoute
  '/event/$eventId/homework': typeof EventEventIdHomeworkRoute
  '/students/$studentId': typeof StudentsStudentIdIndexRoute
  '/classes/$classId/student/$studentId': typeof ClassesClassIdStudentStudentIdRoute
  '/event/$eventId/scorecard/$scorecardId': typeof EventEventIdScorecardScorecardIdRoute
  '/students/$studentId/feedback/$feedbackId': typeof StudentsStudentIdFeedbackFeedbackIdRoute
  '/students/$studentId/feedback': typeof StudentsStudentIdFeedbackIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/classes': typeof ClassesRouteWithChildren
  '/coordination': typeof CoordinationRoute
  '/flags': typeof FlagsRoute
  '/homework': typeof HomeworkRoute
  '/next-classes': typeof NextClassesRoute
  '/students/$studentId': typeof StudentsStudentIdRouteWithChildren
  '/classes/': typeof ClassesIndexRoute
  '/feedback/': typeof FeedbackIndexRoute
  '/students/': typeof StudentsIndexRoute
  '/classes/$classId/homework': typeof ClassesClassIdHomeworkRoute
  '/event/$eventId/homework': typeof EventEventIdHomeworkRoute
  '/students/$studentId/feedback': typeof StudentsStudentIdFeedbackRouteWithChildren
  '/students/$studentId/': typeof StudentsStudentIdIndexRoute
  '/classes/$classId/student/$studentId': typeof ClassesClassIdStudentStudentIdRoute
  '/event/$eventId/scorecard/$scorecardId': typeof EventEventIdScorecardScorecardIdRoute
  '/students/$studentId/feedback/$feedbackId': typeof StudentsStudentIdFeedbackFeedbackIdRoute
  '/students/$studentId/feedback/': typeof StudentsStudentIdFeedbackIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/classes'
    | '/coordination'
    | '/flags'
    | '/homework'
    | '/next-classes'
    | '/students/$studentId'
    | '/classes/'
    | '/feedback'
    | '/students'
    | '/classes/$classId/homework'
    | '/event/$eventId/homework'
    | '/students/$studentId/feedback'
    | '/students/$studentId/'
    | '/classes/$classId/student/$studentId'
    | '/event/$eventId/scorecard/$scorecardId'
    | '/students/$studentId/feedback/$feedbackId'
    | '/students/$studentId/feedback/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/coordination'
    | '/flags'
    | '/homework'
    | '/next-classes'
    | '/classes'
    | '/feedback'
    | '/students'
    | '/classes/$classId/homework'
    | '/event/$eventId/homework'
    | '/students/$studentId'
    | '/classes/$classId/student/$studentId'
    | '/event/$eventId/scorecard/$scorecardId'
    | '/students/$studentId/feedback/$feedbackId'
    | '/students/$studentId/feedback'
  id:
    | '__root__'
    | '/'
    | '/classes'
    | '/coordination'
    | '/flags'
    | '/homework'
    | '/next-classes'
    | '/students/$studentId'
    | '/classes/'
    | '/feedback/'
    | '/students/'
    | '/classes/$classId/homework'
    | '/event/$eventId/homework'
    | '/students/$studentId/feedback'
    | '/students/$studentId/'
    | '/classes/$classId/student/$studentId'
    | '/event/$eventId/scorecard/$scorecardId'
    | '/students/$studentId/feedback/$feedbackId'
    | '/students/$studentId/feedback/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ClassesRoute: typeof ClassesRouteWithChildren
  CoordinationRoute: typeof CoordinationRoute
  FlagsRoute: typeof FlagsRoute
  HomeworkRoute: typeof HomeworkRoute
  NextClassesRoute: typeof NextClassesRoute
  StudentsStudentIdRoute: typeof StudentsStudentIdRouteWithChildren
  FeedbackIndexRoute: typeof FeedbackIndexRoute
  StudentsIndexRoute: typeof StudentsIndexRoute
  EventEventIdHomeworkRoute: typeof EventEventIdHomeworkRoute
  EventEventIdScorecardScorecardIdRoute: typeof EventEventIdScorecardScorecardIdRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ClassesRoute: ClassesRouteWithChildren,
  CoordinationRoute: CoordinationRoute,
  FlagsRoute: FlagsRoute,
  HomeworkRoute: HomeworkRoute,
  NextClassesRoute: NextClassesRoute,
  StudentsStudentIdRoute: StudentsStudentIdRouteWithChildren,
  FeedbackIndexRoute: FeedbackIndexRoute,
  StudentsIndexRoute: StudentsIndexRoute,
  EventEventIdHomeworkRoute: EventEventIdHomeworkRoute,
  EventEventIdScorecardScorecardIdRoute: EventEventIdScorecardScorecardIdRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/classes",
        "/coordination",
        "/flags",
        "/homework",
        "/next-classes",
        "/students/$studentId",
        "/feedback/",
        "/students/",
        "/event/$eventId/homework",
        "/event/$eventId/scorecard/$scorecardId"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/classes": {
      "filePath": "classes.tsx",
      "children": [
        "/classes/",
        "/classes/$classId/homework",
        "/classes/$classId/student/$studentId"
      ]
    },
    "/coordination": {
      "filePath": "coordination.tsx"
    },
    "/flags": {
      "filePath": "flags.tsx"
    },
    "/homework": {
      "filePath": "homework.tsx"
    },
    "/next-classes": {
      "filePath": "next-classes.tsx"
    },
    "/students/$studentId": {
      "filePath": "students/$studentId.tsx",
      "children": [
        "/students/$studentId/feedback",
        "/students/$studentId/"
      ]
    },
    "/classes/": {
      "filePath": "classes/index.tsx",
      "parent": "/classes"
    },
    "/feedback/": {
      "filePath": "feedback/index.tsx"
    },
    "/students/": {
      "filePath": "students/index.tsx"
    },
    "/classes/$classId/homework": {
      "filePath": "classes/$classId/homework.tsx",
      "parent": "/classes"
    },
    "/event/$eventId/homework": {
      "filePath": "event/$eventId/homework.tsx"
    },
    "/students/$studentId/feedback": {
      "filePath": "students/$studentId/feedback.tsx",
      "parent": "/students/$studentId",
      "children": [
        "/students/$studentId/feedback/$feedbackId",
        "/students/$studentId/feedback/"
      ]
    },
    "/students/$studentId/": {
      "filePath": "students/$studentId/index.tsx",
      "parent": "/students/$studentId"
    },
    "/classes/$classId/student/$studentId": {
      "filePath": "classes/$classId/student/$studentId.tsx",
      "parent": "/classes"
    },
    "/event/$eventId/scorecard/$scorecardId": {
      "filePath": "event/$eventId/scorecard/$scorecardId.tsx"
    },
    "/students/$studentId/feedback/$feedbackId": {
      "filePath": "students/$studentId/feedback/$feedbackId.tsx",
      "parent": "/students/$studentId/feedback"
    },
    "/students/$studentId/feedback/": {
      "filePath": "students/$studentId/feedback/index.tsx",
      "parent": "/students/$studentId/feedback"
    }
  }
}
ROUTE_MANIFEST_END */
